import {
  FETCH_QUERY_LOG_REQUEST,
  FETCH_QUERY_LOG_SUCCESS,
  FETCH_QUERY_LOG_ERROR,
  FETCH_QUERY_LOG_FILTER,
  CLEAR_QUERY_LOG,
} from 'actionTypes'

const DEFAULT_STATE = {
  get: {
    record: [],
    error: null,
    isFetching: false,
  },
  filters: {},
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_QUERY_LOG_REQUEST:
      return {
        ...state,
        get: {
          ...state.get,
          isFetching: true,
          error: null,
        },
      }

    case FETCH_QUERY_LOG_SUCCESS:
      return {
        ...state,
        get: {
          record: action.payload,
          isFetching: false,
          error: null,
        },
      }

    case FETCH_QUERY_LOG_ERROR:
      return {
        ...state,
        get: {
          record: {},
          isFetching: false,
          error: action.payload,
        },
      }

    case CLEAR_QUERY_LOG:
      return {
        ...state,
        get: {
          ...state.get,
          record: [],
        },
      }

    case FETCH_QUERY_LOG_FILTER:
      return {
        ...state,
        filters: action.payload,
      }

    default:
      return state
  }
}

export default record
